<template>
  <div>
    <navbar/>
    <router-view/>
  </div>
</template>

<script>
import { Navbar } from './components';

export default {
  components: {
    Navbar
  },
  computed: {
    key() {
      return this.$route.path;
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layout/index.vue